module.exports = __webpack_public_path__ + "img/case-bloomden.c32660eb.png";